module.exports = __webpack_public_path__ + "img/scyd.a8ddad03.png";